module.exports = __webpack_public_path__ + "img/diapositiva-10-5.73bf21c6.jpg";